import {CommonModule} from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit } from "@angular/core";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {Subscription} from "rxjs";
import {APP_CONSTANTS} from "./app.constants";
import {AppFrameComponent} from "./components/app-frame/app-frame.component";
import {IntrospectionService} from "./services/app-services/introspection/introspection.service";
import {setIsLoggedIn, setToken} from "./store/actions/auth.actions";
import {selectUserRoles} from "./store/reducers/auth.reducer";

@Component({
  selector: "mtc-root",
  imports: [CommonModule, AppFrameComponent],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly introspectionService = inject(IntrospectionService);
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  public title = APP_CONSTANTS.MTC_TITLE;

  private _subscriptions: Array<Subscription> = [];

  public ngOnInit(): void {
    const intendedPath = window.location.pathname;
    if (intendedPath !== "/" && intendedPath !== "/unauthorized" && intendedPath !== "") {
      sessionStorage.setItem("intendedPath", intendedPath);
    }

    this._subscriptions.push(
      this.oidcSecurityService.checkAuth().subscribe(({isAuthenticated}) => {
        if (isAuthenticated) {
          this.store.dispatch(setIsLoggedIn({isLoggedIn: true}));
          this.introspectionService.fetchUserRoles();
        }
      })
    );
    this._subscriptions.push(
      this.store.select(selectUserRoles).subscribe(roles => {
        if (roles) {
          const currentUrl = this.router.url;
          const intendedPath = sessionStorage.getItem("intendedPath");

          if (intendedPath && (currentUrl === "/" || currentUrl === "/unauthorized" || currentUrl === "")) {
            sessionStorage.removeItem("intendedPath");
            this.router.navigateByUrl(intendedPath);
          } else if (currentUrl === "/" || currentUrl === "/unauthorized" || currentUrl === "") {
            this.router.navigate([APP_CONSTANTS.DEFAULT_ROUTE]);
          }
        }
      })
    );
    this._subscriptions.push(
      this.oidcSecurityService.getAccessToken().subscribe(token => this.store.dispatch(setToken({token: token})))
    );
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }
}
